@if (fileFound) {
  <button class="btn btn-link np" (click)="downloadFile()">{{fileName}} @if (!showDownloadIndicator) {
    <ep-svg-icon icon="inbox"></ep-svg-icon>
    }@if (showDownloadIndicator) {
    <img title="Downloading file..." src="../../../images/ajax-loader.gif" />
  } </button>
}
@if (!fileFound) {
  <span>{{fileName}}</span>
}